import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import Lock from 'components/Icons/Lock'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import IosLockScreen from './preview/IosLockScreen'

const t = buildTranslate('live_updates.preview_disabled')

export interface PreviewDisabledCardProps {
  onTurnOn?: () => void
}

const PreviewDisabledCard = ({ onTurnOn }: PreviewDisabledCardProps) => {
  const [css] = useStyletron()

  return (
    <IosLockScreen>
      <div
        data-testid="lu-preview-disabled-card"
        className={css({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          paddingTop: '16px',
          paddingRight: '18px',
          paddingBottom: '16px',
          paddingLeft: '18px',
          borderTopLeftRadius: '14px',
          borderTopRightRadius: '14px',
          borderBottomRightRadius: '14px',
          borderBottomLeftRadius: '14px',
          backgroundColor: palette.grey10,
          color: palette.grey90,
        })}
      >
        <span aria-hidden="true" className="d-flex mb-s">
          <Lock />
        </span>
        <Text.Header4 tag="h2" className="m-0">
          {t('title')}
        </Text.Header4>
        <Text.BodyText4 color="grey70" className="mt-xs">
          {t('body')}
        </Text.BodyText4>
        {onTurnOn && (
          <Button kind="minimal" className="mt-s" onClick={onTurnOn}>
            {t('turn_on')}
          </Button>
        )}
      </div>
    </IosLockScreen>
  )
}

export default PreviewDisabledCard
